import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import {
    listservicerequest , createRequest , updateCategory , deleteRequest , listsubcategory,createSubcategory} from '@/services/servicerequest'


@Module({
    namespaced: true,
})


export default class Item extends VuexModule {

    // state 
    ServiceRequestList = [];
    SubcategoryList = [];

    @Action
    public async createRequest(payload) {
        try {
            const data = await createRequest(payload);
            return data;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async createSubcategory(payload) {
        try {
            const data = await createSubcategory(payload);
            return data;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async updateCategory(payload) {
        try {
            const data = await updateCategory(payload.id, payload.data);
            return data
        } catch (error) {
            throw error

        }
    }
    @Action
    public async fetchServicerequestList() {
        try {
            const data = await listservicerequest();
            this.context.commit('setServiceRequestList', data.data);
            return data
        } catch (error) {
            throw error
        }
    }
    @Action
    public async fetchsubcategoryList(payload) {
        try {
            const data = await listsubcategory(payload);
            this.context.commit('setSubcategoryList', data);
            return data
        } catch (error) {
            throw error
        }
    }
    @Action
    public async deleteRequest(payload) {
        try {
            const data = await deleteRequest(payload);
            return data
        } catch (error) {
            throw error
        }
    }

    // mutations 

    @Mutation
    public setServiceRequestList(data: any) {
        this.ServiceRequestList = data;
    }
    
    @Mutation
    public setSubcategoryList(data: any) {
        this.SubcategoryList = data;
    }
   
    
    // getters
    get GetServiceRequestList() {
        return this.ServiceRequestList;
    }
     
    get GetSubcategoryList() {
        return this.SubcategoryList;
    }

}

